module.exports = __webpack_public_path__ + "static/media/azaelfloatflipped.5f757549.png";